import { render, staticRenderFns } from "./AssignAccountLookup.vue?vue&type=template&id=67ca9dd0&"
import script from "./AssignAccountLookup.vue?vue&type=script&lang=js&"
export * from "./AssignAccountLookup.vue?vue&type=script&lang=js&"
import style0 from "./AssignAccountLookup.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports